import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import SearchProductPageLoader from 'pages/search/SearchProductPageLoader';

import Authorize from '../auth/Authorize';
import LazyRouteElement from './common/LazyRoute';

const SearchCustomerPage = lazy(
	() => import('pages/search/SearchCustomerPage')
);
const ProductPopulationPage = lazy(
	() => import('pages/search/ProductPopulationPage')
);

export const getSearchRoutes = (): React.JSX.Element[] => [
	<Route
		key={'product'}
		path={'product'}
		element={
			<Authorize
				area={createArea(AreaName.Individual, OperationType.Read)}>
				<SearchProductPageLoader />
			</Authorize>
		}
	/>,
	<Route
		key="product-population"
		path="Population"
		element={
			<LazyRouteElement
				area={createArea(
					AreaName.IndividualSearchPopulation,
					OperationType.Read
				)}
				Component={ProductPopulationPage}
				path={'Population'}
			/>
		}
	/>,
	<Route
		key={'consumer'}
		path={'consumer'}
		element={
			<LazyRouteElement
				area={createArea(AreaName.Consumer, OperationType.Read)}
				Component={SearchCustomerPage}
				path={'consumer'}
			/>
		}
	/>,
];
